import { render, staticRenderFns } from "./DialogViewLeaveApplications.vue?vue&type=template&id=77c198ec&scoped=true&"
import script from "./DialogViewLeaveApplications.vue?vue&type=script&lang=js&"
export * from "./DialogViewLeaveApplications.vue?vue&type=script&lang=js&"
import style0 from "./DialogViewLeaveApplications.vue?vue&type=style&index=0&id=77c198ec&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c198ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VContainer,VDataTable,VDialog,VIcon,VTooltip})
